const getStringItem = (key: string): string => {
    const stringItem = localStorage.getItem(key);
    return stringItem !== null ? stringItem : "";
}

export const localStorageUtils = {
    getStringItem
}
